import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'

export const Route = createFileRoute('/unsubscribe')({
  head: () => ({ meta: [{ title: 'Cancelar suscripción — Brulo' }] }),
  component: UnsubscribePage,
})

function UnsubscribePage() {
  const [token, setToken] = useState<string | null>(null)
  const [status, setStatus] = useState<'loading' | 'valid' | 'already' | 'invalid' | 'done' | 'error'>('loading')
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    const t = new URLSearchParams(window.location.search).get('token')
    setToken(t)
    if (!t) {
      setStatus('invalid')
      return
    }
    fetch(`/email/unsubscribe?token=${encodeURIComponent(t)}`)
      .then((r) => r.json())
      .then((d) => {
        if (d.valid) setStatus('valid')
        else if (d.reason === 'already_unsubscribed') setStatus('already')
        else setStatus('invalid')
      })
      .catch(() => setStatus('error'))
  }, [])

  const confirm = async () => {
    if (!token) return
    setSubmitting(true)
    try {
      const r = await fetch('/email/unsubscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      })
      const d = await r.json()
      if (d.success) setStatus('done')
      else if (d.reason === 'already_unsubscribed') setStatus('already')
      else setStatus('error')
    } catch {
      setStatus('error')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="max-w-md w-full bg-card border border-border rounded-xl p-8 text-center">
        <h1 className="font-display text-3xl mb-4">Cancelar suscripción</h1>
        {status === 'loading' && <p className="text-muted-foreground">Validando enlace…</p>}
        {status === 'valid' && (
          <>
            <p className="text-muted-foreground mb-6">
              ¿Confirmas que quieres dejar de recibir correos de Brulo?
            </p>
            <button
              onClick={confirm}
              disabled={submitting}
              className="px-6 py-3 rounded-md bg-primary text-primary-foreground font-semibold disabled:opacity-50"
            >
              {submitting ? 'Procesando…' : 'Confirmar cancelación'}
            </button>
          </>
        )}
        {status === 'already' && <p className="text-muted-foreground">Ya cancelaste la suscripción anteriormente.</p>}
        {status === 'done' && <p className="text-muted-foreground">Listo. Ya no recibirás más correos de Brulo.</p>}
        {status === 'invalid' && <p className="text-muted-foreground">Enlace inválido o expirado.</p>}
        {status === 'error' && <p className="text-destructive">Ocurrió un error. Intenta de nuevo más tarde.</p>}
      </div>
    </main>
  )
}
